import React, { FC } from 'react';
import { Icon } from 'antd-mobile';
import './index.less';

type WaitingProps = {
    count?: number;
};

const Waiting: FC<WaitingProps> = (props: WaitingProps) => {
    const { count } = props;
    return (
        <div className="waiting">
            <div className="waiting-tips">
                正在等待服务商返回支付结果
                <br />
                请稍后...
            </div>

            <div className="waiting-loading">
                <Icon type="loading" color="#ff6e00" size="lg" />
            </div>
        </div>
    );
};

export default Waiting;
